var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"postBeacon",attrs:{"id":"beaconMap"}},[_c('input',{attrs:{"type":"file","name":"file","id":"fileId","multiple":""}}),_c('button',{on:{"click":_vm.clickButton}},[_vm._v("提交")])])}
var staticRenderFns = []

export { render, staticRenderFns }